import React, { useEffect, useState } from 'react'
import CommonButton from '../../../Components/Commonbutton'
import { Card, Col, Flex, Row, Spin, Switch, Table } from 'antd'
import CompanyDetails from '../../CompanyhouseandCSFillingButtons/ButtonFiles/companyDetails'
import PSCPage from '../../CompanyhouseandCSFillingButtons/ButtonFiles/pscsPage'
import ShareCapital from '../../CompanyhouseandCSFillingButtons/ButtonFiles/shareCapital'
import SAILAddersss from '../../CompanyhouseandCSFillingButtons/ButtonFiles/sailAddress'
import Officers from '../../CompanyhouseandCSFillingButtons/ButtonFiles/ofiicer'
import Shareholders from '../../CompanyhouseandCSFillingButtons/ButtonFiles/shareHolders'
import { DeleteOutlined, CheckOutlined, EditOutlined } from '@ant-design/icons'
import CusttomBackgroundButton from '../../../Components/CustomBagraoundButton'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import {
    GetCompanyOverViewData,
    GetSubmissionValidation,
    RevetAll,
    SetCSSummary,
    SetInitialCompanyDetail,
    SyncCompanyHouseCH,
} from '../../../Services/CompanyHouse/CompanyOverView'
import {
    type SubmissionInfo,
    type CompanyHouseOverviewSteteIntrface,
} from '../../../Types/CompanyHouse/CompanyOverView'
import style from '../tingtodo.less'
import FullWidthModal from '../../../Components/FullWidthModal'
const CSFillingList = (
    props: CompanyHouseOverviewSteteIntrface
): React.ReactElement => {
    const { companyHouseOverViewList, isLoading } = props
    const [searchParams] = useSearchParams()
    const businessId = Number(searchParams.get('BusinessTypeId'))
    const referenceId = Number(searchParams.get('ReferenceId'))
    const serviceProcessId = Number(searchParams.get('ServiceProcessId'))

    const [activeButton, setActiveButton] = useState(1)
    const [CompanyDetailsBtn, setCompanyDetailsBtn] = useState(true)
    const [OfficerBtn, setOfficerBtn] = useState(false)
    const [SAILAddressBtn, setSAILAddressBtn] = useState(false)
    const [ShareCapitalBtn, setShareCapitalBtn] = useState(false)
    const [ShareholdersBtn, setShareholdersBtn] = useState(false)
    const [PscBtn, setPscBtn] = useState(false)
    const [RevetModalStatus, setRevetModelStatus] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const [selectedValue, setSelectedValue] = useState<number>(1)
    const [showError, setShowError] = useState<boolean>(false)
    const [cardViewDetails, setCardViewDetails] = useState(false)

    useEffect(() => {
        if (companyHouseOverViewList !== null) {
            setCardViewDetails(companyHouseOverViewList.isFileWithChanges === 0)
        }
    }, [companyHouseOverViewList])
    useEffect(() => {
        GetCompanyOverViewData(
            dispatch,
            businessId,
            referenceId,
            serviceProcessId,
            activeButton
        )
    }, [activeButton, businessId, referenceId, serviceProcessId])
    const handleButtonClick = (buttonName: number): void => {
        setActiveButton(buttonName)
        switch (buttonName) {
            case 1:
                setCompanyDetailsBtn(true)
                break
            case 2:
                setOfficerBtn(true)
                break
            case 3:
                setSAILAddressBtn(true)
                break
            case 4:
                setShareCapitalBtn(true)
                break
            case 5:
                setShareholdersBtn(true)
                break
            case 6:
                setPscBtn(true)
                break
            default:
                break
        }
    }

    const handleOtherFunction = (): React.ReactElement => {
        if (activeButton === 1) {
            return <></>
        } else if (activeButton === 2) {
            return <></>
        }
        if (activeButton === 3) {
            return <></>
        }
        if (activeButton === 4) {
            return <></>
        }
        if (activeButton === 5) {
            return <></>
        }
        if (activeButton === 6) {
            return <></>
        }
        return <></>
    }

    const handleSwitchChange = (
        submissionTypeId: number,
        checked: boolean
    ): void => {
        setSelectedIds((prevSelectedIds) => {
            if (checked) {
                // Add the id if switch is checked
                return [...prevSelectedIds, submissionTypeId]
            } else {
                // Remove the id if switch is unchecked
                return prevSelectedIds?.filter((id) => id !== submissionTypeId)
            }
        })
    }
    const columns = [
        {
            title: 'Submission Type',
            key: 'submissionType',
            render: (record: SubmissionInfo) => {
                return (
                    <Flex gap={10}>
                        <Switch
                            onChange={(checked) => {
                                handleSwitchChange(
                                    record.submissionTypeId,
                                    checked
                                )
                            }}
                        />
                        <div> {record.submissionType}</div>
                    </Flex>
                )
            },
        },
        {
            title: 'Last Update Date',
            key: 'lastUpdateDate',
            render: (record: SubmissionInfo) => {
                return <div> {record.lastUpdateDate}</div>
            },
        },
        {
            title: 'Last Update By',
            dataIndex: 'lastUpdateBy',
        },
    ]

    const dataSource =
        companyHouseOverViewList?.cS_Submisssion?.recentModificationsList?.map(
            (item) => ({
                ...item,
                key: item.submissionTypeId.toString(), // or any unique identifier for the key
            })
        )
    const NavigateEditCSPage = (): void => {
        navigate(
            `/confirmation-Statement/details?BusinessTypeId=${businessId}&ReferenceId=${referenceId}&ServiceProcessId=${serviceProcessId}`
        )
    }
    // useEffect(() => {
    //     if (
    //         companyHouseOverViewList?.isFileWithChanges ===  &&
    //         selectedValue === 1
    //     ) {
    //         NavigateEditCSPage()
    //     }
    // }, [companyHouseOverViewList?.isFileWithChanges])
    const OpenRevetActionModal = (): void => {
        setRevetModelStatus(!RevetModalStatus)
    }
    const ChangeModalFunction = (): void => {
        setRevetModelStatus(!RevetModalStatus)
    }
    const RevertAction = (): void => {
        const referenceIds = companyHouseOverViewList?.corporateId
        void RevetAll(dispatch, referenceIds)
        setRevetModelStatus(!RevetModalStatus)
        setCardViewDetails(true)
    }
    const SubmitCsFilling = (): void => {
        try {
            const submissionTypeIdsString = selectedIds.join(',')
            const referenceIds = companyHouseOverViewList?.corporateId
            const dataTosubmit = {
                corporateId: referenceIds,
                isFileWithChanges:
                    companyHouseOverViewList.isFileWithChanges === 0
                        ? selectedValue
                        : companyHouseOverViewList.isFileWithChanges,
                submissionTypeIds: submissionTypeIdsString,
                reviewDate: companyHouseOverViewList?.reviewDate,
            }
            void SetCSSummary(dispatch, dataTosubmit)
        } catch (error) {}
    }

    const handleSwitchChangeC2 = (value: number): void => {
        if (selectedValue === value) {
            setSelectedValue(value) // Deselect the switch if it is already selected
        } else {
            setSelectedValue(value) // Set the selected value
        }
        setShowError(false) // Reset error when a switch is selected
    }

    const ContineButtonFunction = (): void => {
        void ContineButtonAPICall()
    }
    const ContineButtonAPICall = async (): Promise<void> => {
        if (selectedValue === null) {
            setShowError(true)
        } else {
            const dataTosend = {
                companyNumber: companyHouseOverViewList?.companyRegNumber,
                tabIndex: 1,
                clientTypeId: businessId,
                IsClientOnboarding: false,
            }
            const result = await SyncCompanyHouseCH(dispatch, dataTosend)
            if (result === true) {
                const result2 = await SetInitialCompanyDetail(
                    dispatch,
                    businessId,
                    referenceId,
                    serviceProcessId,
                    selectedValue
                )
                if (
                    result2 !== null &&
                    result2 !== undefined &&
                    result2 === true
                ) {
                    const referenceIds = companyHouseOverViewList?.corporateId
                    const result3 = await GetSubmissionValidation(
                        dispatch,
                        referenceIds
                    )
                    if (result3.noOfRecords === 0) {
                        if (selectedValue === 1) {
                            navigate(
                                `/confirmation-Statement/details?BusinessTypeId=${businessId}&ReferenceId=${referenceId}&ServiceProcessId=${serviceProcessId}`
                            )
                        } else {
                            setCardViewDetails(false)
                            // navigate(
                            //     `/confirmation-Statement/summary?BusinessTypeId=${businessId}&ReferenceId=${referenceId}&ServiceProcessId=${serviceProcessId}`
                            // )
                        }
                    } else {
                        RevertAction()
                    }
                }
            }
        }
    }
    return (
        <>
            <div>
                <h1>Summary of Confirmation Statement Filing</h1>
            </div>
            {cardViewDetails ? (
                <Card
                    title={`
            ${companyHouseOverViewList?.clientName} -
            ${companyHouseOverViewList?.companyRegNumber}`}
                >
                    {' '}
                    <Spin spinning={isLoading} size="large">
                        <h3>Would you like to:</h3>
                        <Row>
                            <Col span={2}>
                                <Switch
                                    checked={selectedValue === 1}
                                    onChange={() => {
                                        handleSwitchChangeC2(1)
                                    }}
                                />
                            </Col>
                            <Col span={20}>
                                Check and confirm your company details are up to
                                date before submitting the confirmation
                                statement
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col span={2}>
                                <Switch
                                    checked={selectedValue === 2}
                                    onChange={() => {
                                        handleSwitchChangeC2(2)
                                    }}
                                />
                            </Col>
                            <Col span={20}>
                                File Confirmation statement without any changes
                            </Col>
                        </Row>
                        {showError && (
                            <p style={{ color: 'red' }}>
                                Please complete the below requirements to
                                continue
                            </p>
                        )}

                        <Flex justify="flex-end" align="flex-end" gap={5}>
                            <CusttomBackgroundButton
                                color={'#1dc9b7'}
                                name={'Contine'}
                                icon={<CheckOutlined />}
                                clickAction={ContineButtonFunction}
                            />
                        </Flex>
                    </Spin>
                </Card>
            ) : (
                <Card
                    title={`
                    ${companyHouseOverViewList?.clientName} -
                    ${companyHouseOverViewList?.companyRegNumber}`}
                    extra={
                        companyHouseOverViewList?.isFileWithChanges === 1 && (
                            <div onClick={NavigateEditCSPage}>
                                <a> Edit CS Filling</a>
                            </div>
                        )
                    }
                >
                    <Spin spinning={isLoading} size="large">
                        <div style={{ marginBottom: '15px' }}>
                            <Row gutter={[24, 8]}>
                                <Col span={10}>Next Statement Date </Col>
                                <Col span={8}>
                                    : {companyHouseOverViewList?.statementDate}
                                </Col>
                            </Row>
                            <Row gutter={[24, 8]}>
                                <Col span={10}>
                                    If you file a confirmation today, it will
                                    show the date as
                                </Col>
                                <Col span={8}>
                                    : {companyHouseOverViewList?.reviewDate}
                                </Col>
                            </Row>
                        </div>
                        <CommonButton
                            name="Company Details"
                            isActive={activeButton === 1}
                            clickAction={() => handleOtherFunction()}
                            additionalOnClick={() => {
                                handleButtonClick(1)
                            }}
                        />
                        <CommonButton
                            name="Officer"
                            isActive={activeButton === 2}
                            clickAction={() => handleOtherFunction()}
                            additionalOnClick={() => {
                                handleButtonClick(2)
                            }}
                        />
                        <CommonButton
                            name="SAIL Address"
                            isActive={activeButton === 3}
                            clickAction={() => handleOtherFunction()}
                            additionalOnClick={() => {
                                handleButtonClick(3)
                            }}
                        />
                        <CommonButton
                            name="Share Capital"
                            isActive={activeButton === 4}
                            clickAction={() => handleOtherFunction()}
                            additionalOnClick={() => {
                                handleButtonClick(4)
                            }}
                        />
                        <CommonButton
                            name="Shareholders"
                            isActive={activeButton === 5}
                            clickAction={() => handleOtherFunction()}
                            additionalOnClick={() => {
                                handleButtonClick(5)
                            }}
                        />
                        <CommonButton
                            name="PSC's"
                            isActive={activeButton === 6}
                            clickAction={() => handleOtherFunction()}
                            additionalOnClick={() => {
                                handleButtonClick(6)
                            }}
                        />
                        {CompanyDetailsBtn && activeButton === 1 && (
                            <div>
                                <CompanyDetails
                                    companyHousId={2}
                                    businessId={businessId}
                                    companyHouseOverViewList={
                                        companyHouseOverViewList
                                    }
                                    editId={0}
                                />
                            </div>
                        )}
                        {OfficerBtn && activeButton === 2 && (
                            <div>
                                <Officers
                                    companyHousId={2}
                                    companyHouseOverViewList={
                                        companyHouseOverViewList
                                    }
                                    editId={0}
                                />
                            </div>
                        )}
                        {SAILAddressBtn && activeButton === 3 && (
                            <div>
                                <SAILAddersss
                                    businessId={businessId}
                                    companyHousId={2}
                                    companyHouseOverViewList={
                                        companyHouseOverViewList
                                    }
                                    editId={0}
                                />
                            </div>
                        )}
                        {ShareCapitalBtn && activeButton === 4 && (
                            <div>
                                <ShareCapital
                                    companyHousId={2}
                                    companyHouseOverViewList={
                                        companyHouseOverViewList
                                    }
                                    editId={0}
                                    businessId={businessId}
                                />
                            </div>
                        )}
                        {ShareholdersBtn && activeButton === 5 && (
                            <div>
                                <Shareholders
                                    companyHousId={2}
                                    companyHouseOverViewList={
                                        companyHouseOverViewList
                                    }
                                    editId={0}
                                    businessId={businessId}
                                />
                            </div>
                        )}
                        {PscBtn && activeButton === 6 && (
                            <div>
                                <PSCPage
                                    companyHousId={2}
                                    companyHouseOverViewList={
                                        companyHouseOverViewList
                                    }
                                    editId={0}
                                    businessId={businessId}
                                />
                            </div>
                        )}
                        {companyHouseOverViewList?.cS_Submisssion !== null &&
                        companyHouseOverViewList?.cS_Submisssion
                            ?.submissionNumber === '#' ? (
                            <h5>
                                This is your first submission from IYCONNECT
                            </h5>
                        ) : (
                            <p>
                                Last submitted by{' '}
                                {
                                    companyHouseOverViewList?.cS_Submisssion
                                        ?.submittedBy
                                }{' '}
                                on{' '}
                                {
                                    companyHouseOverViewList?.cS_Submisssion
                                        ?.submissionDate
                                }
                                . Submission number is{' '}
                                <b>
                                    {
                                        companyHouseOverViewList?.cS_Submisssion
                                            ?.submissionNumber
                                    }
                                </b>
                            </p>
                        )}
                        {companyHouseOverViewList?.cS_Submisssion !== null &&
                            companyHouseOverViewList?.cS_Submisssion
                                ?.recentModificationsList?.length > 0 &&
                            dataSource?.length > 0 && (
                                <>
                                    <h3>Pending Submission</h3>
                                    <Table
                                        dataSource={dataSource}
                                        columns={columns}
                                        pagination={false}
                                    />
                                    <br />
                                    <div className={style.misstingInfo}>
                                        You have modified above details after
                                        the last submission. If you wish to
                                        submit this changes this time to company
                                        house, please choose those to submit or
                                        you will loose this changes next time.
                                    </div>
                                </>
                            )}

                        <br />
                        <div style={{ marginTop: '15px' }}>
                            <Flex justify="center" align="flex-end" gap={5}>
                                {companyHouseOverViewList?.isFileWithChanges ===
                                    1 && (
                                    <CusttomBackgroundButton
                                        color={'#175ca9'}
                                        name={'Edit CS Filling'}
                                        icon={<EditOutlined />}
                                        clickAction={NavigateEditCSPage}
                                    />
                                )}
                                <CusttomBackgroundButton
                                    color={'#ff4d4f'}
                                    name={'Revet All'}
                                    icon={<DeleteOutlined />}
                                    clickAction={OpenRevetActionModal}
                                />

                                <CusttomBackgroundButton
                                    color={'#1dc9b7'}
                                    name={'Submit all & CS Filling'}
                                    icon={<CheckOutlined />}
                                    clickAction={SubmitCsFilling}
                                />
                            </Flex>
                        </div>
                        <FullWidthModal
                            modalStatus={RevetModalStatus}
                            closeModal={ChangeModalFunction}
                            tittle="You are about to revert all changes. Click 'Yes' to continue."
                            smallTittle="Warning: This action cannot be undone!"
                            yesButtonFunction={RevertAction}
                        />
                    </Spin>
                </Card>
            )}
        </>
    )
}

const mapStateToProps = (state: any): CompanyHouseOverviewSteteIntrface => {
    return {
        companyHouseOverViewList: state.companyHouse.companyHouseOverViewList,
        isLoading: state.common.isLoading,
    }
}

export default connect(mapStateToProps)(CSFillingList)
